import {formatearNum} from './moneda.utils'
import {
  TIPO_DTE,
  esDocumentoNormativaV2,
  normalizarTipoDte,
  versionDteDocumento,
} from './version-documento.utils'

export const SIN_TOTAL = '--'

const aNumero = (valor: any): number | null => {
  if (valor === null || valor === undefined || `${valor}`.trim() === '') return null
  const numero = Number(`${valor}`.trim())
  return Number.isFinite(numero) ? numero : null
}

const texto = (valor: string | null): string => valor ?? SIN_TOTAL

export const obtenerTotalDocumento = (tipoDte: any, transaccion: any): string => {
  const {resumen, cuerpoDocumento} = transaccion?.DetallesDTE ?? {}

  if (!resumen && !cuerpoDocumento) return SIN_TOTAL

  const tipo = normalizarTipoDte(tipoDte)
  const esVersionDos = esDocumentoNormativaV2(tipo, versionDteDocumento(transaccion?.DetallesDTE))

  switch (tipo) {
    case TIPO_DTE.FACTURA_EXPORTACION:
      if (esVersionDos) {
        return texto(formatearNum(aNumero(resumen?.totalPagar ?? resumen?.montoTotalOperacion)))
      }
      return texto(formatearNum(aNumero(resumen?.extTotal)))

    case TIPO_DTE.DOCUMENTO_LIQUIDACION:
      return texto(formatearNum(cuerpoDocumento?.liquidoApagar))

    case TIPO_DTE.COMPROBANTE_LIQUIDACION:
      return texto(formatearNum(aNumero(resumen?.total ?? resumen?.montoTotalOperacion)))

    case TIPO_DTE.COMPROBANTE_RETENCION:
      return texto(formatearNum(aNumero(resumen?.totalSujetoRetencion)))

    case TIPO_DTE.NOTA_CREDITO:
    case TIPO_DTE.NOTA_DEBITO:
      if (esVersionDos) {
        return texto(formatearNum(aNumero(resumen?.totalPagar ?? resumen?.montoTotalOperacion)))
      }
      return texto(formatearNum(resumen?.montoTotalOperacion))

    default:
      return texto(formatearNum(resumen?.totalPagar ?? resumen?.montoTotalOperacion ?? 0))
  }
}
